import { restPost } from "apiCommandsExecutor/rest";

import { SignInCodeSentDto, TokenPairDto } from "./restModels";
import {
    SignInCodeRequestDto,
    SignInWithCodeRequestDto,
    SignInWithPasswordRequestDto,
    SignUpRequestDto,
} from "./restRequests";

/*
* Вход и регистрация (REST /api/rest/warehouse/v1/auth) — единственные ручки поверхности без
* авторизации: токена у клиента ещё нет. Все четыре — мутации, поэтому при отказе бросают
* Error с текстом от бэка: причину («неверный код», «номер занят») пользователю нужно показать.
* */

export const requestSignInCode = (body: SignInCodeRequestDto) =>
    restPost<SignInCodeSentDto>("/auth/sign-in/code", body);

export const signInWithCode = (body: SignInWithCodeRequestDto) =>
    restPost<TokenPairDto>("/auth/sign-in/code/verify", body);

export const signInWithPassword = (body: SignInWithPasswordRequestDto) =>
    restPost<TokenPairDto>("/auth/sign-in/password", body);

export const signUp = (body: SignUpRequestDto) =>
    restPost<TokenPairDto>("/auth/sign-up", body);
